"use client"

import { useState, useEffect } from "react"
import { createCustomerPortal } from "../../services/pricingService"
import "./ManageBillingsModal.css"
import {
  HiOutlineCreditCard,
  HiOutlineDocumentText,
  HiOutlineArrowTopRightOnSquare,
  HiOutlinePlus,
  HiOutlineArrowDownTray,
  HiOutlineUserCircle,
} from "react-icons/hi2"
import Modal from "./Modal" // adjust path if needed
import { useNavigate } from "react-router-dom"

export default function ManageBillingsPage() {
  const [isLoading, setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("overview")
  const [transactionHistory, setTransactionHistory] = useState([])
  const [currentBillingCycle, setCurrentBillingCycle] = useState(null)

  const navigate = useNavigate()
  const [showNoPlanModal, setShowNoPlanModal] = useState(false)

  useEffect(() => {
    // Initialize page with mock data
    setCurrentBillingCycle({
      status: "active",
      startDate: "2024-01-01",
      endDate: "2024-01-31",
      amount: "$299.99",
      nextBillingDate: "2024-02-01",
    })

    setTransactionHistory([
      { id: 1, date: "2024-01-15", description: "Subscription Payment", amount: "$299.99", status: "completed" },
      { id: 2, date: "2024-01-10", description: "Invoice Download", amount: "-", status: "completed" },
      { id: 3, date: "2024-01-05", description: "Payment Method Updated", amount: "-", status: "completed" },
      { id: 4, date: "2023-12-15", description: "Subscription Payment", amount: "$299.99", status: "completed" },
    ])
  }, [])

  const handleManageBillings = async () => {
    setIsLoading(true)

    try {
      const data = await createCustomerPortal()
      const portalUrl = data?.portalLink

      // ✅ handle your actual API payload: { code: 400, message: "No customer information..." }
      if (!portalUrl) {
        if (data?.code === 400 || /no customer information/i.test(data?.message ?? "")) {
          setShowNoPlanModal(true)
          return
        }
        throw new Error("Stripe portal URL not returned")
      }

      window.open(portalUrl, "_blank", "noopener,noreferrer")
    } catch (error) {
      console.error("Failed to open billing portal:", error)

      // ✅ also handle Axios-style errors if createCustomerPortal throws
      const status = error?.response?.status ?? error?.status
      const apiCode = error?.code ?? error?.response?.data?.code
      const apiMsg = error?.message ?? error?.response?.data?.message

      if (status === 400 || apiCode === 400 || /no customer information/i.test(apiMsg ?? "")) {
        setShowNoPlanModal(true)
      }
    } finally {
      setIsLoading(false)
    }
  }


  const handleUpdatePayment = () => {
    alert("Opening payment method update...")
  }

  const handleDownloadInvoice = (id) => {
    alert(`Downloading invoice ${id}...`)
  }

  return (
    <div className="mbp-container">
      <div className="mbp-page-wrapper">
        {/* Header Section */}
        <div className="mbp-header-section">
          <div className="mbp-header-content">
            <div className="mbp-header-icon">
              <HiOutlineUserCircle size={32} />
            </div>
            <div className="mbp-header-text">
              <h1 className="mbp-title">Billings</h1>
              <p className="mbp-subtitle">View and control your subscription, payment methods, and billing history</p>
            </div>
          </div>
        </div>

        {/* Current Billing Status Card */}
        {/*{currentBillingCycle && (
          <div className="mbp-status-card">
            <div className="mbp-status-header">
              <h2 className="mbp-status-title">Current Billing Cycle</h2>
              <span className="mbp-status-badge">Active</span>
            </div>
            <div className="mbp-status-grid">
              <div className="mbp-status-item">
                <span className="mbp-status-label">Billing Amount</span>
                <span className="mbp-status-value">{currentBillingCycle.amount}</span>
              </div>
              <div className="mbp-status-item">
                <span className="mbp-status-label">Cycle Start</span>
                <span className="mbp-status-value">{currentBillingCycle.startDate}</span>
              </div>
              <div className="mbp-status-item">
                <span className="mbp-status-label">Cycle End</span>
                <span className="mbp-status-value">{currentBillingCycle.endDate}</span>
              </div>
              <div className="mbp-status-item">
                <span className="mbp-status-label">Next Billing Date</span>
                <span className="mbp-status-value">{currentBillingCycle.nextBillingDate}</span>
              </div>
            </div>
          </div>
        )}*/}

        {/* Tab Navigation */}
        {/*<div className="mbp-tabs-container">
          <div className="mbp-tabs-nav">
            <button
              className={`mbp-tab-button ${activeTab === "overview" ? "mbp-tab-active" : ""}`}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>
            <button
              className={`mbp-tab-button ${activeTab === "payment" ? "mbp-tab-active" : ""}`}
              onClick={() => setActiveTab("payment")}
            >
              Payment Methods
            </button>
            <button
              className={`mbp-tab-button ${activeTab === "history" ? "mbp-tab-active" : ""}`}
              onClick={() => setActiveTab("history")}
            >
              Transaction History
            </button>
          </div>
        </div>*/}

        {/* Tab Content */}
        <div className="mbp-tabs-content">
          {/* Overview Tab */}
          {activeTab === "overview" && (
            <div className="mbp-tab-pane">
              <div className="mbp-features-grid">
                <div className="mbp-feature-card">
                  <div className="mbp-feature-icon mbp-icon-invoices">
                    <HiOutlineDocumentText size={24} />
                  </div>
                  <h3 className="mbp-feature-title">View & Download Invoices</h3>
                  <p className="mbp-feature-desc">Access all your past invoices and billing documents</p>
                </div>

                <div className="mbp-feature-card">
                  <div className="mbp-feature-icon mbp-icon-payment">
                    <HiOutlineCreditCard size={24} />
                  </div>
                  <h3 className="mbp-feature-title">Update Payment Methods</h3>
                  <p className="mbp-feature-desc">Manage and update your credit cards and payment info</p>
                </div>

                <div className="mbp-feature-card">
                  <div className="mbp-feature-icon mbp-icon-subscription">
                    <HiOutlineUserCircle size={24} />
                  </div>
                  <h3 className="mbp-feature-title">Manage Subscriptions</h3>
                  <p className="mbp-feature-desc">Upgrade, downgrade, or cancel your plans anytime</p>
                </div>
              </div>

              <div className="mbp-action-section">
                <h3 className="mbp-action-title">Need to manage your billing?</h3>
                <p className="mbp-action-desc">
                  Access the full Stripe billing portal to have complete control over your subscription and payments.
                </p>
                <button className="mbp-btn-primary" onClick={handleManageBillings} disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span className="mbp-spinner"></span>
                      <span>Redirecting to Stripe...</span>
                    </>
                  ) : (
                    <>
                      <span>Manage Billing & Payments</span>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M7 17L17 7M17 7H7m10 0v10"></path>
                      </svg>
                    </>
                  )}
                </button>
                <p className="mbp-portal-notice">You will be securely redirected to Stripe's portal in a new tab</p>
              </div>
            </div>
          )}

          {/* Payment Methods Tab */}
          {activeTab === "payment" && (
            <div className="mbp-tab-pane">
              <div className="mbp-payment-section">
                <div className="mbp-payment-header">
                  <h3 className="mbp-payment-title">Your Payment Methods</h3>
                  <button className="mbp-btn-secondary" onClick={handleUpdatePayment}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Add Payment Method
                  </button>
                </div>

                <div className="mbp-card-list">
                  <div className="mbp-card-item mbp-card-primary">
                    <div className="mbp-card-content">
                      <div className="mbp-card-brand">Visa</div>
                      <div className="mbp-card-number">•••• •••• •••• 4242</div>
                      <div className="mbp-card-meta">
                        <span>Expires 12/25</span>
                        <span className="mbp-card-default">Default</span>
                      </div>
                    </div>
                    <button className="mbp-card-action">Edit</button>
                  </div>

                  <div className="mbp-card-item">
                    <div className="mbp-card-content">
                      <div className="mbp-card-brand">Mastercard</div>
                      <div className="mbp-card-number">•••• •••• •••• 5555</div>
                      <div className="mbp-card-meta">
                        <span>Expires 03/26</span>
                      </div>
                    </div>
                    <button className="mbp-card-action">Edit</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Transaction History Tab */}
          {activeTab === "history" && (
            <div className="mbp-tab-pane">
              <div className="mbp-history-section">
                <h3 className="mbp-history-title">Recent Transactions</h3>
                <div className="mbp-transaction-list">
                  {transactionHistory.map((transaction) => (
                    <div key={transaction.id} className="mbp-transaction-item">
                      <div className="mbp-transaction-content">
                        <div className="mbp-transaction-main">
                          <span className="mbp-transaction-desc">{transaction.description}</span>
                          <span className="mbp-transaction-date">{transaction.date}</span>
                        </div>
                        <div className="mbp-transaction-amount">{transaction.amount}</div>
                      </div>
                      <div className="mbp-transaction-actions">
                        {transaction.description.includes("Invoice") && (
                          <button
                            className="mbp-btn-icon"
                            onClick={() => handleDownloadInvoice(transaction.id)}
                            title="Download"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              <polyline points="7 10 12 15 17 10"></polyline>
                              <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <Modal
        show={showNoPlanModal}
        onClose={() => setShowNoPlanModal(false)}
        type="warning"
        title="No active plan"
        message="You don’t have an active plan yet. Please choose a plan from the pricing page to manage billing and payments."
        onConfirm={() => {
          setShowNoPlanModal(false)
          navigate("/pricing")
        }}
      >
        <div actionLabel="Go to Pricing" />
      </Modal>

    </div>
  )
}
